import {useState} from 'hooks'

export default function useModalState (startOpen = false) {
	const [open, setOpen] = useState(startOpen)
	return [
		open,
		function showModal(){ setOpen(true) },
		function hideModal(){ setOpen(false) }
	]
}